import { renameKeysFromRESTResponseToSDKResponse } from '@wix/sdk-runtime/rename-all-nested-keys';
import { transformRESTFloatToSDKFloat } from '@wix/sdk-runtime/transformations/float';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { EventDefinition } from '@wix/sdk-types';
import { createDiscountRule as universalCreateDiscountRule, deleteDiscountRule as universalDeleteDiscountRule, getDiscountRule as universalGetDiscountRule, queryDiscountRules as universalQueryDiscountRules, updateDiscountRule as universalUpdateDiscountRule, } from './ecom-discounts-v1-discount-rule-discount-rules.universal.js';
export const __metadata = { PACKAGE_NAME: '@wix/ecom' };
export function createDiscountRule(httpClient) {
    return (discountRule) => universalCreateDiscountRule(discountRule, 
    // @ts-ignore
    { httpClient });
}
export function getDiscountRule(httpClient) {
    return (discountRuleId) => universalGetDiscountRule(discountRuleId, 
    // @ts-ignore
    { httpClient });
}
export function updateDiscountRule(httpClient) {
    return (_id, discountRule) => universalUpdateDiscountRule(_id, discountRule, 
    // @ts-ignore
    { httpClient });
}
export function deleteDiscountRule(httpClient) {
    return (discountRuleId) => universalDeleteDiscountRule(discountRuleId, 
    // @ts-ignore
    { httpClient });
}
export function queryDiscountRules(httpClient) {
    return () => universalQueryDiscountRules(
    // @ts-ignore
    { httpClient });
}
export const onDiscountRuleCreated = EventDefinition('wix.ecom.discounts.v1.discount_rule_created', true, (event) => renameKeysFromRESTResponseToSDKResponse(transformPaths(event, [
    {
        transformFn: transformRESTTimestampToSDKTimestamp,
        paths: [
            { path: 'entity.createdDate' },
            { path: 'entity.updatedDate' },
            { path: 'entity.activeTimeInfo.start' },
            { path: 'entity.activeTimeInfo.end' },
            { path: 'metadata.eventTime' },
        ],
    },
    {
        transformFn: transformRESTFloatToSDKFloat,
        paths: [{ path: 'entity.discounts.values.percentage' }],
    },
])))();
export const onDiscountRuleDeleted = EventDefinition('wix.ecom.discounts.v1.discount_rule_deleted', true, (event) => renameKeysFromRESTResponseToSDKResponse(transformPaths(event, [
    {
        transformFn: transformRESTTimestampToSDKTimestamp,
        paths: [
            { path: 'undefined.createdDate' },
            { path: 'undefined.updatedDate' },
            { path: 'undefined.activeTimeInfo.start' },
            { path: 'undefined.activeTimeInfo.end' },
            { path: 'metadata.eventTime' },
        ],
    },
    {
        transformFn: transformRESTFloatToSDKFloat,
        paths: [{ path: 'undefined.discounts.values.percentage' }],
    },
])))();
export const onDiscountRuleUpdated = EventDefinition('wix.ecom.discounts.v1.discount_rule_updated', true, (event) => renameKeysFromRESTResponseToSDKResponse(transformPaths(event, [
    {
        transformFn: transformRESTTimestampToSDKTimestamp,
        paths: [
            { path: 'entity.createdDate' },
            { path: 'entity.updatedDate' },
            { path: 'entity.activeTimeInfo.start' },
            { path: 'entity.activeTimeInfo.end' },
            { path: 'metadata.eventTime' },
        ],
    },
    {
        transformFn: transformRESTFloatToSDKFloat,
        paths: [{ path: 'entity.discounts.values.percentage' }],
    },
])))();
export { AppliedSubjectType, DiscountType, ScopeType, SortOrder, Status, TriggerType, Type, WebhookIdentityType, } from './ecom-discounts-v1-discount-rule-discount-rules.universal.js';
//# sourceMappingURL=ecom-discounts-v1-discount-rule-discount-rules.public.js.map